"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { createSpeechSession, type SpeakOptions } from "@/lib/speech";
const DEFAULT_RATE = 1.4;
export function useSpeech(t0) {
  const $ = _c(10);
  const rate = t0 === undefined ? DEFAULT_RATE : t0;
  const [session] = useState(createSpeechSession);
  let t1;
  if ($[0] !== session.cancel) {
    t1 = () => session.cancel;
    $[0] = session.cancel;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== session) {
    t2 = [session];
    $[2] = session;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== rate || $[5] !== session) {
    t3 = (text, options) => session.speak(text, rate, options);
    $[4] = rate;
    $[5] = session;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== session.cancel || $[8] !== t3) {
    t4 = {
      cancel: session.cancel,
      speak: t3
    };
    $[7] = session.cancel;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}